/**
 * Workspace API client with Zod validation
 */

import { api } from '@services/api';
import {
  WorkspaceListResponseSchema,
  WorkspaceSchema,
  type CreateWorkspaceRequest,
  type Workspace,
} from '../schemas';

const WORKSPACES_PATH = '/workspaces';

export const workspaceApi = {
  /**
   * List user's workspaces
   */
  list: async (): Promise<Workspace[]> => {
    const response = await api.get(WORKSPACES_PATH);
    const validated = WorkspaceListResponseSchema.parse(response.data);
    return validated.workspaces;
  },

  /**
   * Get a specific workspace
   */
  get: async (id: string): Promise<Workspace> => {
    const response = await api.get(`${WORKSPACES_PATH}/${id}`);
    return WorkspaceSchema.parse(response.data);
  },

  /**
   * Create a new workspace
   */
  create: async (data: CreateWorkspaceRequest): Promise<Workspace> => {
    const response = await api.post(WORKSPACES_PATH, data);
    return WorkspaceSchema.parse(response.data);
  },

  /**
   * Delete (terminate) a workspace
   */
  delete: async (id: string): Promise<void> => {
    await api.delete(`${WORKSPACES_PATH}/${id}`);
  },

  /**
   * Extend the workspace session (resets expires_at to now + lifetime)
   */
  extend: async (id: string): Promise<Workspace> => {
    const response = await api.post(`${WORKSPACES_PATH}/${id}/extend`);
    return WorkspaceSchema.parse(response.data);
  },
};
